<script>
  import { onMount, tick } from "svelte";

  import { isObject } from "./utils.js";

  export let id;
  export let schema;
  export let required = false;
  export let value;
  export let error = false;
  export let texts = undefined;
  export let disabled = false;
  export let extras = undefined;

  const original_value = value;

  let base_url = extras && isObject(extras) && Object.keys(extras).includes(id) && extras[id].base_url ? extras[id].base_url : schema.base_url;
  let path = "/";

  let adder = false;
  let newBranch;

  $: path_list = path.split("/");
  $: value = `${ base_url.split("/").slice(-1) }${ path.endsWith("/") ? path.slice(0, -1) : path_list }${ newBranch ? `/${ newBranch }` : '' }`;

  const get_children = async (idx) => {
    const thePath = path_list.slice(1, idx).join("/");
    const url = `${ base_url }/${ thePath ? `${ thePath }/` : thePath }children`;
    const resp = await fetch(url);
    if (resp.ok) {
      const children = await resp.json();
      if (schema.add && !children.length) adder = true;
      return children;
    } else return false;
  }

  const update = async (e, i) => {
    const add = !path_list[i] && e.target.value
    let new_path_list = [...path_list];
    new_path_list[i] = e.target.value;
    if (add) new_path_list.push("");
    else if (i < new_path_list.length) {
      new_path_list = new_path_list.splice(0, i + 1);
      path = new_path_list.join("/");
      await tick();
      new_path_list.push("");
      newBranch = undefined;
    }
    path = new_path_list.join("/");
  }

  onMount(async () => {
    if (original_value) {
      const p = original_value.split("/");
      const pl = []
      for (const segment of p) {
        pl.push(segment);
        path = pl.join("/");
        await tick();
      }
    }
  });
</script>

<div { id } class="lt-tree-path" class:required={ required } class:error={ error }>
  <ul>
    {#each path_list as segment, i}
      <li>
        <!-- svelte-ignore a11y-missing-attribute -->
          {#if !i}
            {#if original_value}
              { original_value.split("/")[0] }
            {:else}
              { base_url.split("/").pop() }
            {/if}
          {:else if i}
            {#await get_children(i) then children}
              {#if children.length}
                <select value={ path_list[i] } on:change={ e => update(e, i) }>
                  <option value="" disabled>Select one</option>
                  {#each children as child}
                    <option>{ child.name }</option>
                  {/each}
                </select>
              {/if}
            {/await}
          {/if}
      </li>
    {/each}
    {#if adder}
      <li><input type="text" placeholder="Type the branch name" bind:value={ newBranch } /></li>
    {/if}
  </ul>
</div>